import { Component, OnInit } from '@angular/core';
import { ToastrService } from 'ngx-toastr';
import { DataSet } from 'src/app/interfaces/investmentcontrolling/inco-project';
import { CustomDialogService } from 'src/app/services/customdialog.service';
import { DefaultValuesService } from 'src/app/services/defaultvalues.service';
import { InvestmentControllingService } from 'src/app/services/investment-controlling.service';
import { MatTableModule } from '@angular/material/table';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatIconModule } from '@angular/material/icon';
import { MatButtonModule } from '@angular/material/button';
import { FormsModule } from '@angular/forms';
import { NgClass } from '@angular/common';

@Component({
  selector: 'app-multiproject-manager',
  standalone: true,
  imports: [
    MatTableModule,
    MatFormFieldModule,
    MatInputModule,
    MatIconModule,
    MatButtonModule,
    FormsModule,
    NgClass
  ],
  templateUrl: './multiproject-manager.component.html',
  styleUrls: ['./multiproject-manager.component.less']
})
export class MultiprojectManagerComponent implements OnInit {
multiprojects: DataSet[] = [];
  editingItemId: number | null = null;
  editingItemName: string = '';
  newItemName: string = '';
  originalItemName: string = '';
  displayedMultiColumns: string[] = ['id', 'name', 'enabled', 'actions'];
  showOnlyEnabled: boolean = false;

  constructor(public defaults: DefaultValuesService,
    private readonly incoService: InvestmentControllingService,
    private readonly toastrService: ToastrService,
    private readonly customDialog: CustomDialogService,
  ) {
  }

  get displayedMultiprojects(): DataSet[] {
    if (!this.showOnlyEnabled) return this.multiprojects;
    return this.multiprojects.filter(x => x.isEnabled === true);
  }
  ngOnInit(): void {
    this.loadData();
  }

  loadData() {
    this.incoService.getMultiprojects(
      this,
      (tthis: MultiprojectManagerComponent, result: DataSet[]) => {
        tthis.multiprojects = result;
      },
      null
    );
  }

  createNewMultiproject() {
    if (!this.newItemName.trim()) return;

    this.incoService.addMultiproject(
      { name: this.newItemName },
      this,
      (tthis: MultiprojectManagerComponent) => {
        tthis.toastrService.success('Multiproject created successfully', 'Creation Successful');
        tthis.newItemName = '';
        tthis.loadData();
      },
      (tthis: any, error: any) => {
        console.error('Error creating multiproject:', error);
        this.toastrService.error('This multiproject cannot be created', 'Creation Failed');
      }
    );
  }

  startEditing(item: DataSet) {
    this.editingItemId = item.id;
    this.editingItemName = item.name;
    this.originalItemName = item.name;
  }

  cancelEditing() {
    this.editingItemId = null;
    this.editingItemName = '';
    this.originalItemName = '';
  }

  saveUpdate(id: number | null) {
    if (!this.editingItemName.trim() || id === null) return;

    this.incoService.updateMultiproject(
      id,
      { name: this.editingItemName },
      this,
      (tthis: MultiprojectManagerComponent) => {
        tthis.toastrService.success('Multiproject updated successfully', 'Update Successful');
        tthis.cancelEditing();
        tthis.loadData();
      },
      (tthis: any, error: any) => {
        console.error('Error updating multiproject:', error);
        this.toastrService.error('This multiproject cannot be updated', 'Update Failed');
      }
    );
  }

  updateMultiprojectStatus(id: number | null, isEnabled: boolean) {
    if (id === null) return;

    this.customDialog.openConfirm({
      title: `${isEnabled ? 'Enable' : 'Disable'} Multiproject`,
      message: `Are you sure you want to ${isEnabled ? 'enable' : 'disable'} multiproject Id: ${id}?`,
      caller: this
    });

    this.customDialog.confirmed().subscribe(res => {
      if (res.confirmed) {
        this.incoService.UpdateMultiprojectStatus(id, isEnabled, this,
          (tthis: MultiprojectManagerComponent) => {
            tthis.toastrService.success('Multiproject status updated successfully', 'Update Successful');
            tthis.loadData();
          },
          (tthis: any, error: any) => {
            console.error('Error updating multiproject status:', error);
            this.toastrService.error('This multiproject cannot be updated', 'Update Failed');
          }
        );
      }
    });
  }

  getEnabledDisplay(enabled: boolean): string {
    return enabled ? 'Enabled' : 'Disabled';
  }

}

